export default "__VITE_PUBLIC_ASSET__5bc8615e__"